import React, { Component, PropTypes } from 'react';
import { Form, Col, FormGroup, ControlLabel, FormControl, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config/config';
import ProgressBar from '../components/progressBar/ProgressBar';
import { getParameterByName } from '../utils/utils'

const appUrlPath = `/${config.appUrlPath}`;

export class ResetPassword extends Component {
  static propTypes = {
    newPassword: PropTypes.string,
    confirmNewPassword: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      confirmNewPassword: '',
      showModal: false,
      message: '',
      callSuccess: false,
      isLoading: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this);
    this.handleChangeConfirmNewPassword = this.handleChangeConfirmNewPassword.bind(this);
    this.validate = this.validate.bind(this);
    this.setLocationHref = this.setLocationHref.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {}
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  // For testing purpose only
  setLocationHref(newHref) {
    window.location.href = newHref;
  }

  handleChangeNewPassword(event) {
    this.setState({ newPassword: event.target.value });
  }

  handleChangeConfirmNewPassword(event) {
    this.setState({ confirmNewPassword: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      this.setState({ isLoading: true })
      axios.post(`${appUrlPath}/resetPassword`, {
        password: this.state.newPassword,
        token: encodeURIComponent(decodeURI(getParameterByName('token', window.location.href))),
        userId: encodeURIComponent(decodeURI(getParameterByName('userId', window.location.href))),
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            message: 'Password has been reset successfully. Please login using the lastest password.',
            showModal: true,
            callSuccess: true,
            isLoading: false
          })
        } else {
          this.setState({
            message: res.data.errMsg,
            showModal: true,
            callSuccess: false,
            isLoading: false
          });
        }
      })
      .catch((err) => {
        if (err) {
          this.setState({
            message: err.response.data.errMsg,
            showModal: true,
            callSuccess: false,
            isLoading: false
          });
        }
      });
    }
  }

  validate() {
    const newPassword = this.state.newPassword;
    const confirmNewPassword = this.state.confirmNewPassword;

    let valid = true;
    const token = getParameterByName('token', window.location.href);
    const userId = getParameterByName('userId', window.location.href);
    if (!token || !userId) {
      valid = false
      this.setState({
        message: 'Invalid URL',
        showModal: true
      });
    }

    if (newPassword !== confirmNewPassword) {
      valid = false
      this.setState({
        message: 'Confirm new password does not match the new password.',
        showModal: true
      });
    }
    return valid;
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  close() {
    this.setState({ showModal: false }, () => {
      if (this.state.callSuccess) {
        window.location.assign('/en/motorb2b/login');
      }
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <Form horizontal onSubmit={this.handleSubmit}>
          <div className="EBaoHome__Container">
            <div className="ebaoUtil__Form">
              <h3 className="ResetPassword__HeaderTwo">Reset Password</h3>
              <div className="ResetPassword__Remarks">
                <ul className="ebaoUtil__Form-ul">
                  <li className="ebaoUtil__Form-li">Password must consist of 8 characters minimum for normal user or 15 characters minimum for admin user </li>
                  <li className="ebaoUtil__Form-li">Password must not match any of your previous 6 passwords </li>
                  <li className="ebaoUtil__Form-li">Password must not contain user name or &apos;AXA&apos; </li>
                  <li className="ebaoUtil__Form-li">Password must contain characters from three of the following four categories: </li>
                  <li className="ebaoUtil__Form-li">* Uppercase characters </li>
                  <li className="ebaoUtil__Form-li">* Lowercase characters </li>
                  <li className="ebaoUtil__Form-li">* Numbers </li>
                  <li className="ebaoUtil__Form-li">* Special characters </li>
                </ul>
              </div>
              <br /><br />
              <FormGroup controlId="">
                <Col componentClass={ControlLabel} sm={3}>
                  New Password
                </Col>
                <Col sm={4}>
                  <FormControl type="password"
                    placeholder="Password"
                    value={this.state.newPassword}
                    onChange={this.handleChangeNewPassword}
                    autoComplete="off"
                    required
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={5} />
              </FormGroup>
              <FormGroup controlId="">
                <Col componentClass={ControlLabel} sm={3}>
                  Confirm New Password
                </Col>
                <Col sm={4}>
                  <FormControl type="password"
                    placeholder="Confirm New Password"
                    value={this.state.confirmNewPassword}
                    onChange={this.handleChangeConfirmNewPassword}
                    autoComplete="off"
                    required
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={5} />
              </FormGroup>
            </div>
            <br /><br />
           <FormGroup controlId="buttonGroup">
             <div className="ebaoUtil__ButtonGroup">
               <button type="submit" className="btn btn-axa">Confirm</button>{' '}
               <button type="button" className="btn btn-axa" onClick={this.handleClick}>Back to Home</button>
             </div>
           </FormGroup>
          </div>
        </Form>
      </div>
    )
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/app/pages/ResetPassword.js